/*
 * @Descripttion:
 * @version:
 * @Author: renqiang_hu
 * @Date: 2021-03-31 14:02:41
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-11-14 17:30:34
 * @FilePath: \wanguo_web\common_web\src\router\page\index.js
 */
import Layout from '@/page/index/'

export default [{
  path: '/login',
  name: '登录页',
  component: () =>
    import( /* webpackChunkName: "page" */ '@/page/login/index'),
  meta: {
    keepAlive: true,
    isTab: false,
    isAuth: false
  }
},

  // {
  //   path: '/pageList',
  //   name: '列表页',
  //   component: () =>
  //     import( /* webpackChunkName: "page" */ '@/page/bigScreen/index')
  // }, {
  //   path: '/build/:id',
  //   name: 'build',
  //   component: () =>
  //     import( /* webpackChunkName: "page" */ '@/page/bigScreen/build')
  // }, {
  //   path: '/view/:id',
  //   name: 'view',
  //   component: () =>
  //     import( /* webpackChunkName: "page" */ '@/page/bigScreen/view')
  // },
  {
    path: '/lock',
    name: '锁屏页',
    component: () =>
      import( /* webpackChunkName: "page" */ '@/page/lock/index'),
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false
    }
  },
  {
    path: '/privacy/kvkk',
    name: '隐私协议',
    component: () =>
      import( /* webpackChunkName: "views" */ '@/views/privacy/kvkk'),
    meta: {
      keepAlive: false,
      isTab: false,
      isAuth: false
    }
  },

  {
    path: '/404',
    component: () =>
      import( /* webpackChunkName: "page" */ '@/components/error-page/404'),
    name: '404',
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false
    }

  },
  {
    path: '/403',
    component: () =>
      import( /* webpackChunkName: "page" */ '@/components/error-page/403'),
    name: '403',
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false
    }
  },
  {
    path: '/500',
    component: () =>
      import( /* webpackChunkName: "page" */ '@/components/error-page/500'),
    name: '500',
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false
    }
  },
  {
    path: '/',
    name: '主页',
    redirect: '/wel'
  },
  {
    path: '/myiframe',
    component: Layout,
    redirect: '/myiframe',
    children: [{
      path: ":routerPath",
      name: 'iframe',
      component: () =>
        import( /* webpackChunkName: "page" */ '@/components/iframe/main'),
      props: true
    }]

  },
  {
    path: '*',
    redirect: '/404'
  }
]
